import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app.routing';
import {HttpClientModule} from '@angular/common/http';

import {AppComponent} from './app.component';
import {NavbarComponent} from './shared/navbar/navbar.component';
import {FooterComponent} from './shared/footer/footer.component';

import {Angulartics2Module} from 'angulartics2';
import {Angulartics2GoogleAnalytics} from 'angulartics2/ga';
import {NgxPageScrollModule} from 'ngx-page-scroll';

import {HomeModule} from './home/home.module';

import {PortfolioService} from './shared/profile/portfolio.service'
import {TrackingServiceService} from './shared/service/tracking-service.service';
import {GalleryComponent} from './gallery/gallery.component';
import {LinenotificationService} from './shared/service/linenotification.service';

import {PLATFORM_ID, APP_ID, Inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        FooterComponent,
        GalleryComponent,
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'portfolio'}),
        NgbModule.forRoot(),
        FormsModule,
        RouterModule,
        AppRoutingModule,
        HomeModule,
        HttpClientModule,
        Angulartics2Module.forRoot([Angulartics2GoogleAnalytics]),
        NgxPageScrollModule
    ],
    providers: [PortfolioService, TrackingServiceService, LinenotificationService],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(@Inject(PLATFORM_ID) private platformId: Object,
                @Inject(APP_ID) private appId: string) {
        const platform = isPlatformBrowser(platformId) ?
            'in the browser' : 'on the server';
        console.log(`Running ${platform} with appId=${appId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts